import { Box, Slide, SlideProps, Snackbar, Stack } from "@mui/material";
import { Custom } from "components";
import { useApp, useTheme } from "contexts";
import { Enums } from "utils";

// icons
import {
  CheckCircleRounded,
  CloseRounded,
  InfoRounded,
  ReportRounded,
  WarningRounded,
} from "@mui/icons-material";

type Props = {};

export const Message = (props: Props) => {
  const { theme } = useTheme();
  const { feedback, hasFeedback, unsetFeedback } = useApp();

  const isSuccess = feedback.severity === Enums.EnumFeedback.Success;
  const isWarning = feedback.severity === Enums.EnumFeedback.Warning;
  const isError = feedback.severity === Enums.EnumFeedback.Error;
  const isInfo = feedback.severity === Enums.EnumFeedback.Info;

  const SlideTransition = (props: SlideProps) => {
    return <Slide {...props} direction="up" />;
  };

  return (<Snackbar
    open={hasFeedback}
    autoHideDuration={3000}
    onClose={(_, reason) => {
      if (reason !== "clickaway") {
        unsetFeedback();
      }
    }}
    anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
    TransitionComponent={SlideTransition}
  >
    <Box
      sx={{
        color: "white",
        p: theme.spacing.sm,
        pl: theme.spacing.lg,
        borderRadius: theme.border.radius,
        left: theme.spacing.sm * theme.spacing.factor,
        bottom: theme.spacing.sm * theme.spacing.factor,
        backgroundColor: theme.color.status[feedback.severity].color,
      }}
    >
      <Stack
        width={1}
        direction="row"
        alignItems="center"
        spacing={theme.spacing.md}
      >
        {isSuccess && (
          <CheckCircleRounded
            sx={{ color: theme.color.status[feedback.severity].text }}
          />
        )}
        {isWarning && (
          <WarningRounded
            sx={{ color: theme.color.status[feedback.severity].text }}
          />
        )}
        {isError && (
          <ReportRounded
            sx={{ color: theme.color.status[feedback.severity].text }}
          />
        )}
        {isInfo && (
          <InfoRounded
            sx={{ color: theme.color.status[feedback.severity].text }}
          />
        )}
        <Custom.Typography
          sx={{ width: 1 }}
          weight={theme.font.medium}
          color={theme.color.status[feedback.severity].text}
        >
          {feedback.message}
        </Custom.Typography>
        <Custom.IconButton size="small" onClick={unsetFeedback}>
          <CloseRounded
            sx={{ color: theme.color.status[feedback.severity].text }}
          />
        </Custom.IconButton>
      </Stack>
    </Box>
  </Snackbar>);
};
